module.exports = __webpack_public_path__ + "static/media/5C.12408f64.svg";